import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const CloseRoundIcon = ({
  // !!! c'est celui du kit UI?
  width = normalize(24),
  height = normalize(24),
  color = theme.colors["neutral.400"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMin meet"
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 11.125L14.625 8.49999C14.741 8.38395 14.8984 8.31877 15.0625 8.31877C15.2266 8.31877 15.384 8.38395 15.5 8.49999C15.616 8.61602 15.6812 8.77339 15.6812 8.93749C15.6812 9.10158 15.616 9.25896 15.5 9.37499L12.875 12L15.5 14.625C15.616 14.741 15.6812 14.8984 15.6812 15.0625C15.6812 15.2266 15.616 15.384 15.5 15.5C15.384 15.616 15.2266 15.6812 15.0625 15.6812C14.8984 15.6812 14.741 15.616 14.625 15.5L12 12.875L9.37496 15.5C9.25893 15.616 9.10155 15.6812 8.93746 15.6812C8.77336 15.6812 8.61599 15.616 8.49996 15.5C8.38392 15.384 8.31874 15.2266 8.31874 15.0625C8.31874 14.8984 8.38392 14.741 8.49996 14.625L11.125 12L8.49996 9.37499C8.38392 9.25896 8.31874 9.10158 8.31874 8.93749C8.31874 8.77339 8.38392 8.61602 8.49996 8.49999C8.61599 8.38395 8.77336 8.31877 8.93746 8.31877C9.10155 8.31877 9.25893 8.38395 9.37496 8.49999L12 11.125Z"
      fill={color}
    />
  </Svg>
);

export default CloseRoundIcon;
